/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/lodash/_realNames.js
// module id = ../../../../lodash/_realNames.js
// module chunks = vendor